<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :options.sync="paginationOptions"
    :server-items-length="totalItems"
    :loading="loading"
    :footer-props="{
      itemsPerPageOptions: [10,25,50]
    }"
    fixed-header
    class="header-nowrap"
  >
    <template v-slot:body="{ items }">
      <tbody>
        <NoDataAvailable
          :headers="headers"
          :items="items"
        />
        <v-hover
          v-for="item in items"
          :key="item.id"
        >
          <tr>
            <td>
              <a
                  v-if="item.incident"
                  @click="goToIncident(item)"
              >
                {{ item.sequenceNumber }}
              </a>
              <span v-else>{{ item.sequenceNumber }}</span>
            </td>
            <td>{{ item.incidentNumber }}</td>
            <td>{{ item.incidentDateTime | datetimeToClientTimezone }}</td>
            <td>{{ item.status }}</td>
            <td>
              {{ item.exportedAt | datetimeToClientTimezone }}
            </td>
            <td>
              {{ item.error }}
            </td>
          </tr>
        </v-hover>
      </tbody>
    </template>
  </v-data-table>
</template>

<script>
import impersonateMixins from '@/mixins/impersonateMixins';
import fixedHeader from '@/mixins/fixedHeader';
import NoDataAvailable from '../NoDataAvailable';

export default {
  name: 'ExportTable',

  components: {
    NoDataAvailable,
  },

  mixins: [impersonateMixins, fixedHeader],

  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    useImpersonate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paginationOptions: this.pagination,
      headers: [
        {
          text: this.$t('externalServiceExports.tableHeaders.sequenceNumber'),
          value: 'sequenceNumber',
        },
        {
          text: this.$t('externalServiceExports.tableHeaders.incidentNumber'),
          value: 'incidentNumber',
        },
        {
          text: this.$t('externalServiceExports.tableHeaders.incidentDateTime'),
          value: 'incidentDateTime',
        },
        {
          text: this.$t('externalServiceExports.tableHeaders.status'),
          value: 'status',
        },
        {
          text: this.$t('externalServiceExports.tableHeaders.exportedAt'),
          value: 'exportedAt',
        },
        {
          text: this.$t('externalServiceExports.tableHeaders.error'),
          value: 'error',
        },
      ],
    };
  },

  watch: {
    /**
     * Watch pagination options and update pagination
     */
    paginationOptions() {
      this.$emit('update:pagination', this.paginationOptions);
    },
  },
  methods: {
    /**
     * Impersonate user to client and go to incident view page.
     *
     * @param {Object} exportItem - Export object.
     */
    goToIncident(exportItem) {
      if (this.useImpersonate) {
        this.impersonateToIncident(
          exportItem.clientId,
          exportItem.incident.id,
        );
      } else {
        const url = `/incident/view?ID=${exportItem.incident.id}`;
        const win = window.open(url, '_blank');
        win.focus();
      }
    },
  },
};
</script>

<style lang="scss" module>
.actions {
  width: 20%;
}

.deleted {
  background-color: $red-light;
}
</style>
